import { defineMessages } from 'react-intl';

export const teamTrialUpgradeRequestModalMessages = defineMessages({
  titlePractice: {
    id: 'riiamrx3Y8',
    defaultMessage: 'Request Practice',
    description: 'Title on the modal for asking an admin to upgrade to Practice',
  },
  titleClinician: {
    id: 'D/wn0zZbdC',
    defaultMessage: 'Request Clinician',
    description: 'Title on the modal for asking an admin to upgrade to Clinician',
  },
  descriptionPractice: {
    id: 'l0NsSYolyo',
    defaultMessage: 'Ask your admin to upgrade your team to Practice.',
    description: 'Primary supporting copy on the team upgrade request modal (Practice)',
  },
  descriptionClinician: {
    id: 'H7kOLTqucy',
    defaultMessage: 'Ask your admin to upgrade your team to Clinician.',
    description: 'Primary supporting copy on the team upgrade request modal (Clinician)',
  },
  evidenceTagline: {
    id: 'reFkR8y+xh',
    defaultMessage: 'Everything in Scribe Team, plus premium Evidence.',
    description:
      'Secondary line under the primary description on the team upgrade request modal',
  },
  messageLabel: {
    id: 'KWZH3blKck',
    defaultMessage: 'Message',
    description: 'Label for the message field on the team upgrade request modal',
  },
  messagePlaceholderPractice: {
    id: 'GUaFeOTwIU',
    defaultMessage:
      "Hi, our Practice trial is ending and I'd like to keep using it. Evidence has been useful for clinical work. Could we upgrade the team?",
    description:
      'Placeholder hint text in the message field on the team upgrade request modal (Practice tier)',
  },
  messagePlaceholderClinician: {
    id: '6Ev5SPspBK',
    defaultMessage:
      "Hi, our Clinician trial is ending and I'd like to keep using it. Evidence has been useful for clinical work. Could we upgrade the team?",
    description:
      'Placeholder hint text in the message field on the team upgrade request modal (Clinician tier)',
  },
  send: {
    id: '+NFtCBzazS',
    defaultMessage: 'Send',
    description: 'Primary submit button on the team upgrade request modal',
  },
  cancel: {
    id: '7L8g6xBLbb',
    defaultMessage: 'Cancel',
    description: 'Dismiss button on the team upgrade request modal',
  },
  back: {
    id: 'akteSfAwhP',
    defaultMessage: 'Back',
    description:
      'Back control on the team upgrade request modal (closes without sending)',
  },
  requestFailed: {
    id: 'dIsHSMGNOF',
    defaultMessage: 'Could not send request',
    description: 'Toast title when notifying team admins of a plan upgrade request fails',
  },
  requestSentSuccess: {
    id: 'PgAkAPaeXK',
    defaultMessage: 'Request sent to your admin',
    description:
      'Success toast after the user submits a team plan upgrade request for their admin to review',
  },
});
